import { memo, useMemo } from 'react';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import CarouselSimple from '@bridebook/ui/src/components/bbcommon/carousel-simple/carousel-simple';
import type {
  CountyWithTopSupplier,
  TypeWithTopSupplier,
} from '@bridebook/toolbox/src/search-suppliers/landing-page-search/transform-landing-items';
import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import SearchSupplierCard from './search-supplier-card';

type CarouselItem = CountyWithTopSupplier | TypeWithTopSupplier;

interface IProps {
  items: CarouselItem[];
  buildItem: (location: string | { name: string; value: string }) => {
    title: string;
    href: string;
  };
}

const SearchSuppliersCarousel = ({ items, buildItem }: IProps) => {
  const isMobile = useSelector(getIsMobile);
  const isTablet = useSelector(getIsTablet);

  const slides = useMemo(
    () =>
      items
        .filter((item) => item.imageUri !== null)
        .map((item) => {
          const location = 'county' in item ? item.county : item.type;
          const { title, href } = buildItem(location);
          return (
            <SearchSupplierCard
              href={href}
              key={title}
              slide={{ title, imageUrl: item.imageUri as string }}
            />
          );
        }),
    [items, buildItem],
  );

  if (slides.length === 0) return null;

  return (
    <div className="mb-4">
      <CarouselSimple
        noSSR={false}
        show={5}
        fixedWidthSlideMobile={207}
        noPaddingLeft
        isMobile={isMobile}
        isTablet={isTablet}
        slides={slides}
      />
    </div>
  );
};

export default memo(SearchSuppliersCarousel);
